import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams } from 'Models'
import { GetItemsPayload } from 'Types/getItemsPayload'
import { SberGeoUnitModel } from 'Pages/orders_design'

export type SberGeoAddressState = {
	items: ResponseCatalog<SberGeoUnitModel>
	params: RequestParams
}

export const sberGeoAddressInitialState: SberGeoAddressState = {
	items: new ResponseCatalog<SberGeoUnitModel>(),
	params: new RequestParams(),
}

export namespace sberGeoAddressNS {
	export type getSberGeoAddress = PayloadAction<GetItemsPayload>
	export type setSberGeoAddress = PayloadAction<ResponseCatalog<SberGeoUnitModel>>
	export type setSberGeoAddressParams = PayloadAction<RequestParams>
	export type pushSberGeoAddress = PayloadAction<SberGeoUnitModel>
}

export const sberGeoAddressSlice = createSlice({
	name: 'sberGeoAddress',
	initialState: sberGeoAddressInitialState,
	reducers: {
		getSberGeoAddress: (state, action: sberGeoAddressNS.getSberGeoAddress) => {},
		setSberGeoAddress: (state, action: sberGeoAddressNS.setSberGeoAddress) => {
			state.items = action.payload
		},
		setSberGeoAddressParams: (state, action: sberGeoAddressNS.setSberGeoAddressParams) => {
			state.params = action.payload
		},
		clearAll: (state) => {
			state.items = new ResponseCatalog<SberGeoUnitModel>()
			state.params = new RequestParams()
		},
		pushSberGeoAddress: (state, action: sberGeoAddressNS.pushSberGeoAddress) => {
			const nextState = { ...state }
			nextState.items.entries.push(action.payload)
			return nextState
		},
	},
})
